import { Action } from '@ngrx/store';


export const SET_RED_AGUA = '[RED_AGUA] Set RED';
export const SET_RED_SUCCESS = '[RED_AGUA] Set RED Succes';
export const SET_RED_FAILURE = '[RED_AGUA] Set RED Failure';
export const VISIBLE_RED = '[RED_AGUA] Visible RED';
export const HIDDEN_RED = '[RED_AGUA] HIDDEN RED';


export class SetRedAguaAction implements Action {
  readonly type = SET_RED_AGUA;
  constructor() {}
}
export class SetRedAguaSuccesAction implements Action {
  readonly type = SET_RED_SUCCESS;
  constructor() {}
}
export class SetRedAguaFailureAction implements Action {
  readonly type = SET_RED_FAILURE;
  constructor(public error: any) {
  }
}

export class VisibleRedAction implements Action {
  readonly type = VISIBLE_RED;
  constructor() {}
}

export class HiddenRedAction implements Action {
  readonly type = HIDDEN_RED;
  constructor() {}
}

export type RedAguaActions =
  | SetRedAguaAction
  | SetRedAguaSuccesAction
  | SetRedAguaFailureAction
  | VisibleRedAction
  | HiddenRedAction;
